import React, { Component } from 'react';
import { Modal, Header, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { submit, isValid, isDirty } from 'redux-form';
import PropTypes from 'prop-types';

import { TaxRateFieldEnum } from 'Common/FieldEnum';
import { TAX_RATE_ENTRY_FORM_NAME } from 'Common/FormEnum';
import TaxRateForm from './TaxRateForm';

class TaxRateModal extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    rowData: PropTypes.object,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
  };

  static defaultProps = {
    isOpen: false,
  };

  state = {};

  render() {
    const {
      isOpen,
      onClose,
      rowData,
      onSubmit,
      submit,
      isValid,
      loading,
      isDirty,
      usedTaxRateNames,
      handleSaveAndAssignSitesClick,
    } = this.props;

    const isNew = !rowData || !rowData[TaxRateFieldEnum.Id];

    return (
      <Modal
        open={isOpen}
        onClose={() => onClose(isDirty)}
        size="large"
        closeIcon
      >
        <Header content={`${isNew ? 'Add' : 'Edit'} Tax Rate`} icon="signup" />

        <Modal.Content className="p-t-0">
          <Modal.Description>
            <TaxRateForm
              onSubmit={onSubmit}
              initialValues={rowData}
              usedTaxRateNames={usedTaxRateNames}
            />
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="orange"
            size="big"
            content="Back"
            onClick={() => onClose(isDirty)}
            disabled={loading}
            loading={loading}
            className="pull-left"
          />
          <Button
            color="orange"
            size="big"
            content="Save and Assign Sites"
            onClick={handleSaveAndAssignSitesClick}
            disabled={!isValid || loading}
            loading={loading}
          />
          <Button
            color="orange"
            size="big"
            content="Save"
            onClick={() => submit(TAX_RATE_ENTRY_FORM_NAME)}
            disabled={!isValid || loading}
            loading={loading}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isValid: isValid(TAX_RATE_ENTRY_FORM_NAME)(state),
    isDirty: isDirty(TAX_RATE_ENTRY_FORM_NAME)(state),
  };
};

const mapDispatchToProps = { submit };

export default connect(mapStateToProps, mapDispatchToProps)(TaxRateModal);



// WEBPACK FOOTER //
// ./src/pages/controlinformation/components/taxRates/TaxRateModal.js